import * as Common from "../../commons/common"

export class SearchCondition{
  grade: string = ""
  room_name: string = ""
  user_name: string = ""
  page: number = 1
  row_count: number =  100
}

export class TeacherAccessibleStudentPage {
  id: number
  login_id: string
  user_id: number
  user_name: string
  grade: number
  grade_name: string
  room_name: string
  room_name_cache: string
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.login_id = x.login_id;
    this.user_id = x.user_id;
    this.user_name = x.user_name;
    this.grade = x.grade;
    this.grade_name = Common.GetGradeNameByGrade(x.grade);
    this.room_name = x.room_name;
    this.room_name_cache = x.room_name;
  }
}